export default __webpack_public_path__ + "static/media/mtn.459eb388.png";